/**
 * Exponential backoff helper for WebSocket reconnection.
 *
 * Computes the delay before the next reconnect attempt using
 * exponential growth with clamping and +/-10% jitter.
 *
 * Jitter prevents thundering-herd on multi-tab scenarios
 * where all tabs might reconnect simultaneously.
 */

/**
 * Computes the reconnect delay for a given attempt index.
 *
 * @param attempt - Zero-based reconnect attempt count
 * @param baseMs - Base delay in milliseconds (default 1000)
 * @param maxMs - Maximum delay in milliseconds (default 8000)
 * @returns Delay in milliseconds, always >= 0
 */
export function computeBackoff(attempt: number, baseMs = 1000, maxMs = 8000): number {
  const exp = Math.min(maxMs, baseMs * Math.pow(2, attempt));
  // +/- 10% uniform jitter
  const jitter = exp * 0.1 * (Math.random() * 2 - 1);
  return Math.max(0, exp + jitter);
}
